import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Select({ className, children, ...rest }) {
    return (_jsx("select", { className: classNames(className, "cvr-control"), ...rest, children: children }));
}
